import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  SFPageContainer,
  SFAppBar,
  SFLoadingScreen,
} from "@sf-core";
import HeaderLayout from "../../containers/headerLayout";
import { LPAssets, launchPadLayoutActions } from "@sf-launchpad";
import env from "env";

const PreviewWrapper = ({
  children,
  routes,
  isSiteReady,
  isPageLoaderAnimationFinished,
  resetLoadingState,
  setLoadingState,
  state,
  showLoader,
}) => {

  useEffect(() => {
    resetLoadingState();
  }, []);

  return (
    <>
      <SFAppBar
        dividerLine={false}
        disableGradient={showLoader}
        logo={<LPAssets.SFLogo />}
        showUserAvatar={false}
        items={[]}
        itemsRight={[]}
      />
      <SFPageContainer sx={{ mt: "80px", height: "calc(100vh - 80px)" }}>
        <HeaderLayout routes={routes} />
        {children}
      </SFPageContainer>
      {env.REACT_APP_ENABLE_PAGE_LOADER && (
        <SFLoadingScreen
          showLogo
          isVisible={!isSiteReady || !isPageLoaderAnimationFinished}
          onAnimationFinished={() => {
            setLoadingState({
              isPageLoaderAnimationFinished: true,
            });
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  isSiteReady: state.launchPadLayout.isSiteReady,
  isPageLoaderAnimationFinished:
    state.launchPadLayout.isPageLoaderAnimationFinished,
  state,
  showLoader: state.launchPadLayout.showLoader,
});

const mapDispatchToProps = (dispatch) => {
  return {
    resetLoadingState: () => dispatch(launchPadLayoutActions.resetState()),
    setLoadingState: (o) => dispatch(launchPadLayoutActions.setState(o)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewWrapper);
